module.exports = __webpack_public_path__ + "img/xinzhuang-1.00e4b2c8.jpg";